var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "sc-28fa28fe-5 jYhuOw",
    width: 24,
    height: 24,
    viewBox: "-1 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2116 4.60226L12.9591 9.22734L14.123 6.50034L19.2116 4.60226Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79166 4.60226L10.9866 9.27133L9.88026 6.50372L4.79166 4.60226Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9616 15.3242L15.297 17.8651L18.8597 18.8463L19.8815 15.3817L16.9616 15.3242Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13199 15.3817L5.147 18.8463L8.70293 17.8651L7.04508 15.3242L4.13199 15.3817Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50983 11.0341L7.52188 12.5262L11.0474 12.6852L10.9289 8.89243L8.50983 11.0341Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4933 11.0341L13.0403 8.85178L12.9591 12.6885L16.4846 12.5295L15.4933 11.0341Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69937 17.8651L10.8309 16.8365L8.99373 15.4054L8.69937 17.8651Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1689 16.8365L15.297 17.8651L15.006 15.4054L13.1689 16.8365Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.297 17.8651L13.1689 16.8366L13.3414 18.217L13.3245 18.8023L15.297 17.8651Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69937 17.8651L10.6786 18.8023L10.6651 18.217L10.8309 16.8366L8.69937 17.8651Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7157 14.4919L8.9462 13.9743L10.1947 13.3991L10.7157 14.4919Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2873 14.4919L13.8083 13.3991L15.0635 13.9743L13.2873 14.4919Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69927 17.8651L9.00716 15.3242L7.04141 15.3783L8.69927 17.8651Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9923 15.3242L15.2968 17.8651L16.9615 15.3783L14.9923 15.3242Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4846 12.5262L12.9591 12.6852L13.2873 14.4919L13.8084 13.3991L15.0636 13.9742L16.4846 12.5262Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94649 13.9742L10.195 13.3991L10.716 14.4919L11.0442 12.6852L7.51871 12.5262L8.94649 13.9742Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51871 12.5262L8.99724 15.4054L8.94649 13.9742L7.51871 12.5262Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0636 13.9742L15.0094 15.4054L16.488 12.5262L15.0636 13.9742Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0439 12.6852L10.7157 14.4919L11.1285 16.6268L11.2199 13.8152L11.0439 12.6852Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9593 12.6852L12.7868 13.8084L12.8747 16.6268L13.2875 14.4919L12.9593 12.6852Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2874 14.4919L12.8747 16.6268L13.1724 16.8366L15.0096 15.4054L15.0637 13.9742L13.2874 14.4919Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9462 13.9742L8.99695 15.4054L10.8341 16.8366L11.1319 16.6268L10.7157 14.4919L8.9462 13.9742Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3244 18.8023L13.3413 18.217L13.1789 18.0817H10.8173L10.6617 18.217L10.6752 18.8023L8.69595 17.8651L9.38955 18.4336L10.7936 19.4012H13.1992L14.6101 18.4336L15.2969 17.8651L13.3244 18.8023Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1689 16.8366L12.8712 16.6268H11.1287L10.831 16.8366L10.6652 18.217L10.8208 18.0817H13.1824L13.3448 18.217L13.1689 16.8366Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4755 9.52849L19.9999 6.97404L19.2082 4.59891L13.1689 9.07173L15.4932 11.0341L18.7751 11.9916L19.4992 11.1457L19.1845 10.9191L19.6852 10.4623L19.3029 10.1679L19.8037 9.78563L19.4755 9.52849Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99991 6.9774L4.5311 9.53185L4.18938 9.7856L4.69688 10.1679L4.31456 10.4623L4.8153 10.919L4.50065 11.1457L5.22469 11.9916L8.50657 11.0341L10.831 9.07171L4.79162 4.60226L3.99991 6.9774Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7785 11.9882L15.4966 11.0307L16.4845 12.5227L15.006 15.402L16.9582 15.3783H19.8781L18.7785 11.9882Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50987 11.0341L5.22799 11.9916L4.13516 15.3817H7.04825L9.00046 15.4054L7.52192 12.5262L8.50987 11.0341Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9589 12.6852L13.1687 9.0717L14.1194 6.50034H9.88004L10.8308 9.0717L11.0405 12.6852L11.1217 13.8186L11.1285 16.6234H12.8709L12.8777 13.8186L12.9589 12.6852Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109648,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.b95c2b60.svg";
export { ForwardRef as ReactComponent };